import { render, staticRenderFns } from "./naver.vue?vue&type=template&id=8a28b21a"
import script from "./naver.vue?vue&type=script&lang=js"
export * from "./naver.vue?vue&type=script&lang=js"
import style0 from "./naver.vue?vue&type=style&index=0&id=8a28b21a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports